module.exports = __webpack_public_path__ + "media/styles/images/svg/circle-ex-gray-dark-on-red-dark-5ea84c2190c7c0d00e7f5e34a6acb952.svg";